import clsx from "clsx";
import { Badge as BadgeProps } from "./index.types";
import "./index.css";

export function Badge({
  className,
  tone = "chrome",
  size = "md",
  children,
}: BadgeProps) {
  return (
    <span
      className={clsx(
        "badge",
        `badge--${size}`,
        `badge--${tone}`,
        className
      )}
    >
      {children}
    </span>
  );
}

export default Badge;
